import React, { FC } from 'react'
import { Button, useTheme } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HomeIcon from '@mui/icons-material/Home'
import { useNavigate } from 'react-router-dom'

interface BackButtonProps {
  onClick?: () => void
  text?: string
  position?: 'fixed' | 'relative'
  variant?: 'topLeft' | 'bottomLeft'
}

export const BackButton: FC<BackButtonProps> = ({
  onClick,
  text = '戻る',
  position = 'fixed',
  variant = 'bottomLeft',
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      navigate(-1)
    }
  }

  // Use HomeIcon for "処方箋画面へ戻る" text, otherwise use ArrowBackIcon
  const icon = text?.includes('処方箋画面へ戻る') ? (
    <HomeIcon />
  ) : (
    <ArrowBackIcon />
  )

  return (
    <Button
      variant="outlined"
      startIcon={icon}
      onClick={handleClick}
      sx={[
        {
          position: position,
          color: theme.palette.primary.dark,
          borderWidth: '1.5px',
          borderColor: theme.palette.primary.dark,
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            borderColor: theme.palette.primary.dark,
            borderWidth: '1.5px',
          },
          transition: 'all 0.2s ease-in-out',
        },
        variant === 'topLeft'
          ? { top: 24, left: 24 }
          : { bottom: 24, left: 24 },
        position === 'fixed' && {
          zIndex: 1000,
        },
      ]}
    >
      {text}
    </Button>
  )
}
